exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  background: #f1f2f2; }\n\n.site-footer {\n  background: #444;\n  color: #a3a3a3;\n  font-weight: 500;\n  min-height: 6.25rem;\n  line-height: 2;\n  font-size: 0.875rem;\n  padding: 2em 1.25rem; }\n  .site-footer .wrapper ul {\n    list-style: none;\n    padding: 0;\n    margin-left: 0.625rem; }\n    .site-footer .wrapper ul li a {\n      color: #a3a3a3;\n      text-decoration: none; }\n    .site-footer .wrapper ul.social-media {\n      border-top: 1px solid #666;\n      display: flex;\n      padding: 1.5em 1em 0 0.625rem;\n      margin: 0;\n      align-items: center; }\n      .site-footer .wrapper ul.social-media li {\n        margin-right: 10px;\n        display: inline-block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/Ivanchis/Documents/Project/app2soft/app2soft-site-development/config/src"],"sourceMap":true}!./src/components/footer/style.scss
// module id = 403
// module chunks = 0